/* GENERATED by Challenges/build/export_guide_pdfs.py. Do not hand-edit.
   The slugs whose guide is also published as assets/guide-<slug>.pdf.
   training-content.js reads it to put a PDF link on the matching card. */
export const GUIDE_PDFS = [
  "argmax",
  "countifs",
  "datatable-sequence",
  "find-startnum",
  "index-match",
  "indirect",
  "let-byrow",
  "sb-every-xth",
  "scan",
  "sort-large",
  "sort-sortby",
  "sprint-anchors",
  "sprint-arrays-1",
  "sprint-arrays-2",
  "sprint-arrays-3",
  "sprint-explode",
  "sprint-find",
  "sprint-grid-distance",
  "sprint-if-logic",
  "sprint-ifs-family",
  "sprint-index2d",
  "sprint-indirect",
  "sprint-join",
  "sprint-lookup-1",
  "sprint-lookup-2",
  "sprint-lookup-3",
  "sprint-offset",
  "sprint-reduce",
  "sprint-sort-1a",
  "sprint-sort-2a",
  "sprint-sort-3a",
  "sprint-sort-4a",
  "sprint-substitute",
  "sprint-text-basic",
  "sprint-textbefore-after",
  "sprint-textsplit",
  "sprint-transpose",
  "sprint-wrap",
  "sprint-xlookup-1a",
  "sprint-xlookup-2a",
  "sprint-xlookup-3a",
  "sprint-xlookup-4a",
  "sumifs",
  "sumproduct",
  "text-modern",
  "text-parse",
  "time-windows",
  "unique-filter",
  "xlookup"
];
